import PropTypes from 'prop-types';
import React from 'react';

import { Small, Medium, LargeUp } from 'components/MediaQuery';
import { COLLECTION_ITEM_TYPES, COLLECTION_N_COLUMNS } from 'constants/collection';
import ParentCollectionBanner from 'containers/ParentCollectionBannerContainer';

import DesktopLayout from './DesktopLayout';
import Empty from './Empty';
import Grid from './Grid';
import MobileLayout from './MobileLayout';

const CollectionContent = ({
  isEmpty,
  isLoading,
  topBanner,
  secondRowBanner,
  rows,
  bottomBanner,
  nColumns,
  hasMobileQuickAddRow,
}) => {
  return isEmpty && !isLoading ? (
    <Empty />
  ) : (
    <>
      {topBanner && <ParentCollectionBanner banner={topBanner} isLoading={isLoading} />}
      <Grid
        banner={secondRowBanner}
        nColumns={nColumns}
        rows={rows}
        hasMobileQuickAddRow={hasMobileQuickAddRow}
      />
      {bottomBanner && <ParentCollectionBanner banner={bottomBanner} isLoading={isLoading} />}
    </>
  );
};

CollectionContent.propTypes = {
  isEmpty: PropTypes.bool,
  isLoading: PropTypes.bool,
  topBanner: PropTypes.shape({}),
  secondRowBanner: PropTypes.shape({}),
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  bottomBanner: PropTypes.shape({}),
  nColumns: PropTypes.number,
  hasMobileQuickAddRow: PropTypes.bool,
};

CollectionContent.defaultProps = {
  isEmpty: false,
  isLoading: false,
  topBanner: null,
  secondRowBanner: null,
  bottomBanner: null,
  nColumns: COLLECTION_N_COLUMNS.TWO,
  hasMobileQuickAddRow: true,
};

const CollectionParent = props => (
  <div className="CollectionParent">
    <Small>
      <MobileLayout {...props}>
        <CollectionContent
          {...props}
          rows={props.mobileRows}
          nColumns={COLLECTION_N_COLUMNS.TWO}
          hasMobileQuickAddRow={true}
        />
      </MobileLayout>
    </Small>
    <Medium>
      <MobileLayout {...props}>
        <CollectionContent
          {...props}
          rows={props.mobileRows}
          nColumns={COLLECTION_N_COLUMNS.TWO}
          hasMobileQuickAddRow={true}
        />
      </MobileLayout>
    </Medium>
    <LargeUp>
      <DesktopLayout {...props}>
        <CollectionContent
          {...props}
          rows={props.desktopRows}
          nColumns={COLLECTION_N_COLUMNS.THREE}
        />
      </DesktopLayout>
    </LargeUp>
  </div>
);

CollectionParent.propTypes = {
  desktopRows: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(Object.values(COLLECTION_ITEM_TYPES)),
        id: PropTypes.string,
      })
    )
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEmpty: PropTypes.bool,
  isFiltering: PropTypes.bool,
  topBanner: PropTypes.shape({}),
  mobileRows: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(Object.values(COLLECTION_ITEM_TYPES)),
        id: PropTypes.string,
      })
    )
  ).isRequired,
  secondRowBanner: PropTypes.shape({}),
  bottomBanner: PropTypes.shape({}),
  faq: PropTypes.shape({}),
};

CollectionParent.defaultProps = {
  isFiltering: false,
  isEmpty: false,
  topBanner: null,
  secondRowBanner: null,
  bottomBanner: null,
  faq: null,
};

export default CollectionParent;
